import { AssociationMember } from "@boark/shared/types/association-member";
import { associationMemberSchema } from "@boark/shared/types/association-member";
import * as z from "zod";

import { request } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getAssociationMembers(): Promise<AssociationMember[]> {
  return request(`${API_BASE_URL}/association/members`, {
    schema: z.array(associationMemberSchema),
    headers: { "Content-Type": "application/json" },
  });
}
